module.exports = __webpack_public_path__ + "static/media/dominion-dynamics.0f3fa306.png";